import { render, staticRenderFns } from "./ControversyBanner.vue?vue&type=template&id=498ec063&scoped=true"
import script from "./ControversyBanner.vue?vue&type=script&lang=js"
export * from "./ControversyBanner.vue?vue&type=script&lang=js"
import style0 from "./ControversyBanner.vue?vue&type=style&index=0&id=498ec063&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498ec063",
  null
  
)

export default component.exports